export default "__VITE_ASSET__3KcJC36y__"